import React from 'react';
import PropTypes from 'prop-types';
import { Nav, Button, Offcanvas } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BsFillGeoAltFill } from 'react-icons/bs';
//custom-hooks
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
// own components
import LanguageSwitcher from 'components/navbar/LanguageSwitcher';
import MyAccount from 'components/navbar/MyAccount';
import MenuItems from 'components/navbar/MenuItems';

const NavbarOffCanvas = ({
  isDesktop,
  blogCategories,
  closeSession,
  showOffCanvas,
  setShowOffCanvas,
  activeKey }) => {
  const { t } = useTranslation(['header']);
  const { assignedLibrary } = useAssignedLibrary();

  return (
    <Offcanvas
      show={!isDesktop && showOffCanvas}
      id='offcanvasNavbar-mobile'
      aria-labelledby='offcanvasNavbar-mobile'
      placement="start"
      onHide={() => setShowOffCanvas(false)}
    >
      <Offcanvas.Header closeButton>
        <div className="select-language d-lg-none">
          <LanguageSwitcher className="lang-select-desktop" />
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body className='header-mobile-desktop-nav pb-0 container-fluid container container-responsive'>
        <Nav className="mx-auto navbar-left offcanvas-nav" activeKey={activeKey}>
          {/* ICONO USUARIOS <992*/}
          <MyAccount
            setShowOffCanvas={setShowOffCanvas}
            closeSession={closeSession} />

          {/* MENU */}
          <MenuItems
            blogCategories={blogCategories}
            isDesktop={isDesktop}
            setShowOffCanvas={setShowOffCanvas} />

          <Button
            variant="primary"
            className="location-search my-2"
            onClick={() => setShowOffCanvas(false)}
          >
            <Link to={`/${assignedLibrary}/librerias/mapa`} className="text-decoration-none text-white">
              <BsFillGeoAltFill className='location-icon' />{t('searchBookstores').toUpperCase()}
            </Link>
          </Button>
        </Nav>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

NavbarOffCanvas.propTypes = {
  isDesktop: PropTypes.bool,
  blogCategories: PropTypes.any,
  closeSession: PropTypes.func,
  showOffCanvas: PropTypes.bool,
  setShowOffCanvas: PropTypes.func,
  activeKey: PropTypes.string
};

export default NavbarOffCanvas;
